import { render, staticRenderFns } from "./love-value-mall-poster.vue?vue&type=template&id=2208a932&scoped=true&"
import script from "./love-value-mall-poster.vue?vue&type=script&lang=js&"
export * from "./love-value-mall-poster.vue?vue&type=script&lang=js&"
import style0 from "./love-value-mall-poster.vue?vue&type=style&index=0&id=2208a932&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2208a932",
  null
  
)

export default component.exports